
const config = {
    //ipAddress: '192.168.1.200',
    ipAddress: '127.0.0.1', // Development IP address
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
    googleHostedDomain: process.env.REACT_APP_GOOGLE_HOSTED_DOMAIN || '',

    // ipAddress: window.location.hostname === '192.168.1.200'
    // ? '192.168.1.200'
    // : '207.6.223.164'
    
  };
  
  export default config;
